import CycleTable from './CycleTable';

export default CycleTable;
